// extracted by mini-css-extract-plugin
export default {"external":"externalLink_external__Fb8wd"};